export const FETCH_COMPARTMENTS = '@@box/FETCH_COMPARTMENTS';
export const FETCH_COMPARTMENTS_SUCCESS = '@@box/FETCH_COMPARTMENTS_SUCCESS';
export const FETCH_COMPARTMENTS_ERROR = '@@box/FETCH_COMPARTMENTS_ERROR';
export const CANCEL_FETCH_COMPARTMENTS = '@@box/CANCEL_FETCH_COMPARTMENTS';

export const FETCH_COMPARTMENT = '@@box/FETCH_COMPARTMENT';
export const FETCH_COMPARTMENT_SUCCESS = '@@box/FETCH_COMPARTMENT_SUCCESS';
export const FETCH_COMPARTMENT_ERROR = '@@box/FETCH_COMPARTMENT_ERROR';
export const CANCEL_FETCH_COMPARTMENT = '@@box/CANCEL_FETCH_COMPARTMENT';

export const SAVE_COMPARTMENT = '@@box/SAVE_COMPARTMENT';
export const SAVE_COMPARTMENT_SUCCESS = '@@box/SAVE_COMPARTMENT_SUCCESS';
export const SAVE_COMPARTMENT_ERROR = '@@box/SAVE_COMPARTMENT_ERROR';
export const CANCEL_SAVE_COMPARTMENT = '@@box/CANCEL_SAVE_COMPARTMENT';

export const REMOVE_COMPARTMENT = '@@box/REMOVE_COMPARTMENT';
export const REMOVE_COMPARTMENT_SUCCESS = '@@box/REMOVE_COMPARTMENT_SUCCESS';
export const REMOVE_COMPARTMENT_ERROR = '@@box/REMOVE_COMPARTMENT_ERROR';
export const CANCEL_REMOVE_COMPARTMENT = '@@box/CANCEL_REMOVE_COMPARTMENT';

export const SET_COMPARTMENT_MODE = '@@box/SET_COMPARTMENT_MODE';
export const RESET_COMPARTMENT_SELECTED = '@@box/RESET_COMPARTMENT_SELECTED';
export const CHANGE_COMPARTMENT_SORT = '@@box/CHANGE_COMPARTMENT_SORT';

export function changeCompartmentSort(sort, desc) {
  return {
    type: CHANGE_COMPARTMENT_SORT,
    sort,
    desc
  };
}

export const fetchCompartment = config => ({
  type: FETCH_COMPARTMENT,
  ...config
});

export const fetchCompartmentSuccess = payload => ({
  type: FETCH_COMPARTMENT_SUCCESS,
  payload
});

export const fetchCompartmentError = err => ({
  type: FETCH_COMPARTMENT_ERROR,
  payload: err
});

export const saveCompartment = (payload, id) => ({
  type: SAVE_COMPARTMENT,
  payload,
  id
});

export const saveCompartmentSuccess = (payload) => ({
  type: SAVE_COMPARTMENT_SUCCESS,
  payload
});

export const saveCompartmentError = err => ({
  type: SAVE_COMPARTMENT_ERROR,
  payload: err
});

export const fetchCompartments = config => ({
  type: FETCH_COMPARTMENTS,
  ...config
});

export const fetchCompartmentsSuccess = payload => ({
  type: FETCH_COMPARTMENTS_SUCCESS,
  payload
});

export const fetchCompartmentsError = err => ({
  type: FETCH_COMPARTMENTS_ERROR,
  payload: err
});

export const removeCompartment = payload => ({
  type: REMOVE_COMPARTMENT,
  ...payload
});

export const removeCompartmentSuccess = payload => ({
  type: REMOVE_COMPARTMENT_SUCCESS,
  ...payload
});

export const removeCompartmentError = err => ({
  type: REMOVE_COMPARTMENT_ERROR,
  payload: err
});

export const setCompartmentCreatingMode = payload => ({
  type: SET_COMPARTMENT_MODE,
  payload,
});

export const resetCompartmentSelected = () => ({
  type: RESET_COMPARTMENT_SELECTED
});
